import React from 'react';
import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';
import { useIntl, defineMessages } from 'react-intl';
import { DropdownComponent, TextAreaComponent } from '../../../components/prime-formik';

const i18nMessages = defineMessages({
  surveyItemCode: {
    id: 'menu.item-bank-management.survey-item-code',
    defaultMessage: 'Survey Item Code',
  },
  kssTextType: {
    id: 'menu.item-bank-management.kss-text-type',
    defaultMessage: 'KSS Text Type',
  },
  level: {
    id: 'menu.item-bank-management.level',
    defaultMessage: 'Level',
  },
  sequence: {
    id: 'menu.item-bank-management.sequence',
    defaultMessage: 'Sequence',
  },
  text: {
    id: 'menu.item-bank-management.text',
    defaultMessage: 'Text',
  },
});

const AddKssText = ({
  surveyItems, availableKssTextTypes, availableTextLevels, availableSequences,
}) => {
  const { formatMessage } = useIntl();

  const { values } = useFormikContext();

  const surveyItemOptions = surveyItems.map(surveyItem => ({
    value: surveyItem.code,
    label: surveyItem.code,
  }));

  const kssTextTypeOptions = availableKssTextTypes.map(kssTextType => ({
    value: kssTextType,
    label: kssTextType,
  }));

  const filteredTextLevels = availableTextLevels.find(textLevel => textLevel.kssTextType === values.kssTextType);

  const textLevelOptions = filteredTextLevels
    ? filteredTextLevels.levels.map(level => ({
      value: level,
      label: level,
    }))
    : [];

  const filteredSequences = availableSequences.find(
    sequence => sequence.kssTextType === values.kssTextType && sequence.level === values.level,
  );

  const sequenceOptions = filteredSequences
    ? filteredSequences.sequences.map(sequence => ({
      value: sequence,
      label: sequence,
    }))
    : [];

  return (
    <>
      <div className="items-controls">
        <div>
          <div className="input-label">{formatMessage(i18nMessages.surveyItemCode)}</div>
          <div>
            <Field id="itemCode" name="itemCode" component={DropdownComponent} options={surveyItemOptions} />
          </div>
        </div>
        <div>
          <div className="input-label">{formatMessage(i18nMessages.kssTextType)}</div>
          <div>
            <Field id="kssTextType" name="kssTextType" component={DropdownComponent} options={kssTextTypeOptions} />
          </div>
        </div>
        <div>
          <div className="input-label">{formatMessage(i18nMessages.level)}</div>
          <div>
            <Field id="level" name="level" component={DropdownComponent} options={textLevelOptions} />
          </div>
        </div>
        <div>
          <div className="input-label">{formatMessage(i18nMessages.sequence)}</div>
          <div>
            <Field id="sequence" name="sequence" component={DropdownComponent} options={sequenceOptions} />
          </div>
        </div>
      </div>

      <div className="items-controls">
        <div>
          <div className="input-label">{formatMessage(i18nMessages.text)}</div>
          <div>
            <Field id="text" name="text" component={TextAreaComponent} />
          </div>
        </div>
      </div>
    </>
  );
};


AddKssText.propTypes = {
  surveyItems: PropTypes.arrayOf(PropTypes.any).isRequired,
  availableKssTextTypes: PropTypes.arrayOf(PropTypes.any).isRequired,
  availableTextLevels: PropTypes.arrayOf(PropTypes.any).isRequired,
  availableSequences: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default AddKssText;
